import { BaseResponse } from "../models/BaseResponse";
import { MessageAttachmentGetRequest } from "../models/MessageAttachmentGetRequest";
import { MessageAttachmentGetResponse } from "../models/MessageAttachmentGetResponse";
import { MessageAttachmentPutRequest } from "../models/MessageAttachmentPutRequest";
import { MessageAttachmentPutResponse } from "../models/MessageAttachmentPutResponse";
import { MessageGetRequest } from "../models/MessageGetRequest";
import { MessageGetResponse } from "../models/MessageGetResponse";
import { MessageSendRequest } from "../models/MessageSendRequest";
import { MessageSendResponse } from "../models/MessageSendResponse";
import { MessageReadPutRequest } from "../models/MessageReadPutRequest";
import { MessageReadPutResponse } from "../models/MessageReadPutResponse";
import { APIService } from "./APIService";
import { MessageAttachmentDetail } from "../models/MessageAttachmentDetail";


export class MessageAPIService {
    private _apiService: APIService;

    constructor(){
        this._apiService = new APIService();
    }

    public async getAllMessages(request: MessageGetRequest, token: string | null):Promise<BaseResponse<MessageGetResponse>>{
        return this._apiService.sendRequest<BaseResponse<MessageGetResponse>, MessageGetRequest>("Message/GetAllMessages", "POST", request, token);
    }

    public async getNewMessages(request: MessageGetRequest, token: string | null):Promise<BaseResponse<MessageGetResponse>>{
        return this._apiService.sendRequest<BaseResponse<MessageGetResponse>, MessageGetRequest>("Message/GetNewMessages", "POST", request, token);
    }

    public async getAllSentMessages(request: MessageGetRequest, token: string | null):Promise<BaseResponse<MessageGetResponse>>{
        return this._apiService.sendRequest<BaseResponse<MessageGetResponse>, MessageGetRequest>("Message/GetAllSentMessages", "POST", request, token);
    }

    public async getMessageAttachment(request: MessageAttachmentGetRequest, token: string | null): Promise<BaseResponse<MessageAttachmentDetail>> {
        return this._apiService.sendRequest<BaseResponse<MessageAttachmentDetail>, MessageAttachmentGetRequest>("Message/GetMessageAttachment", "POST", request, token);
    }

    public async putDocumentAttachment(request: MessageAttachmentPutRequest, token: string | null): Promise<BaseResponse<MessageAttachmentPutResponse>> {
        return this._apiService.sendRequest<BaseResponse<MessageAttachmentPutResponse>, MessageAttachmentPutRequest>("Message/PutDocumentAttachment", "POST", request, token);
    }

    public async sendMessage(request: MessageSendRequest, token: string | null):Promise<BaseResponse<MessageSendResponse>> {
        return this._apiService.sendRequest<BaseResponse<MessageSendResponse>, MessageSendRequest>("Admin/SendMessage", "POST", request, token);
    }

    public async markMessagesAsRead(request: MessageReadPutRequest, token: string | null): Promise<BaseResponse<MessageReadPutResponse>> {
        return this._apiService.sendRequest<BaseResponse<MessageReadPutResponse>, MessageReadPutRequest>("Message/MarkMessagesAsRead", "POST", request, token);
    }
}